// GEL BÊTA le 07/10/2026. Voir docs/GEL_BETA.md.
// Architecture figée : paiement dual, Coco via settings, rôles user_roles/has_role, âge 18 soft, pas de Connect.
// Porte ouverte : corrections de retours testeurs uniquement sur ordre Hiti, lot unique, sans rouvrir ces règles.
// Interdit sans Hiti : tama-wip→main, édition client.ts / types.ts / .env / config.toml / previewAuthStorage.
/**
 * Politique son UNIQUE pour toute la session.
 *
 * Pourquoi : iOS n'autorise l'autoplay que muet. Avant, chaque diapositive
 * gérait son propre `muted`, ce qui rendait le son aléatoire au remontage.
 * Ici, une seule variable de module décide pour tous les éléments du pool.
 */

let audioUnlocked = false;
let audioUnlockedAt: number | null = null;
// Vrai tant que le voile de connexion / onboarding est affiché : son interdit.
let onboardingMuted = false;
const listeners = new Set<() => void>();
// AudioContext unique de session : signale à iOS qu'un flux audio reste ouvert.
// Relié à aucune vidéo (pas de MediaElementSource).
let keepAliveAudio: AudioContext | null = null;

function openKeepAliveAudio() {
  if (keepAliveAudio || typeof window === "undefined") return;
  const Ctx = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctx) return;
  try {
    keepAliveAudio = new Ctx();
    void keepAliveAudio.resume().catch(() => undefined);
  } catch {
    keepAliveAudio = null;
  }
}

/** Le son est-il autorisé (l'utilisateur a déjà interagi avec la page) ? */
export function isAudioUnlocked(): boolean {
  return audioUnlocked && !onboardingMuted;
}

/** Horodatage de l'unlock, pour détecter un « unlock dans le même geste ». */
export function getAudioUnlockTime(): number | null {
  return audioUnlockedAt;
}

/** Notifié une seule fois, au tout premier geste utilisateur de la session. */
export function onAudioUnlocked(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/**
 * À appeler UNIQUEMENT depuis un geste qui vise le lecteur : WebKit accorde
 * son autorisation élément par élément, un clic ailleurs ne vaut rien.
 */
export function markAudioUnlocked() {
  if (onboardingMuted || audioUnlocked) return;
  audioUnlocked = true;
  audioUnlockedAt = performance.now();
  openKeepAliveAudio();
  listeners.forEach((listener) => listener());
  listeners.clear();
}

/** Coupe le son pendant la connexion / l'onboarding (toutes les vidéos de la page). */
export function setOnboardingMuted(muted: boolean) {
  onboardingMuted = muted;
  if (!muted || typeof document === "undefined") return;
  document.querySelectorAll("video").forEach((video) => {
    video.muted = true;
  });
}
